import React, { useEffect, useState } from 'react';
import vizier from '../../config/vizier.json'
import classNames from 'classnames';
import { useOutletContext } from 'react-router-dom';
import { getVizierByID } from '../../helpers/getVizierByID';
import { useSocketState } from '../../helpers/useSocket';

import { WaterLevel } from '../../components/WaterLevel';
import { GoldenAge } from '../../components/GoldenAge';
import { MalianCows } from '../../components/MalianCows';

import { useQuery } from "react-query";

function LiveGameDashboard() {
    const { socket } = useOutletContext()

    console.log("LiveGameDashboard")

    const [match] = useSocketState('Match');

    const [liveGameOverlay] = useSocketState('LiveGameOverlay');
    const [count, setCount] = useState(0)

    const [sheepState, setSheepState] = useState({});
    const [vizierState, setVizierState] = useState([]);
    const [cisternState, setCisternState] = useState([]);
    const [goldenAgeState, setGoldenAgeState] = useState({})
    const [cowState, setCowState] = useState({})

    const fetchMaps = async () => {
        const res = await fetch(`${window.__RUNTIME_CONFIG__.REACT_APP_BACKEND_URL}/api/config/maps`);
        return res.json();
    };

    const {data: maps, status} = useQuery("maps", fetchMaps);

    function updateSheep(data) {
        socket.emit('updateSheep', { ...sheepState, ...data });
    }

    function updateVizier(data) {
        socket.emit('updateVizier', { ...vizierState, ...data });
    }

    function updateCistern(data) {
        socket.emit('updateCistern', { ...cisternState, ...data });
    }

    function updateGoldenAge(data) {
        socket.emit('updateGoldenAge', { ...goldenAgeState, ...data });
    }

    function updateCow(data) {
        socket.emit('updateCow', { ...cowState, ...data });
    }

    function sendTestData(data) {
        setCount(count + 1)
        socket.emit('addLiveGameTick', {
            tick: count,
            ingameTime: 1
        })
    }

    function resetLiveGame(data) {
        //setCount(count++)
        socket.emit('resetLiveGame', {
            tick: count,
            ingameTime: 1
        })
    }

    //useSocketEvent('updateSheep', onUpdateSheep)

    useEffect(() => {

        function onUpdateSheep(value) {
            console.log(`Received updateSheep`, value);
            setSheepState(oldState => ({ ...oldState, ...value }));
        }

        function onUpdateVizier(value) {
            console.log(`Received updateVizier`, value);
            setVizierState(oldState => ({ ...oldState, ...value }));
        }

        function onUpdateCistern(value) {
            console.log(`Received updateCistern`, value);
            setCisternState(oldState => ({ ...oldState, ...value }));
        }

        function onUpdateGoldenAge(value) {
            console.log(`Received updateGoldenAge`, value);
            setGoldenAgeState(oldState => ({ ...oldState, ...value }));
        }

        function onUpdateCow(value) {
            console.log(`Received onUpdateCow`, value);
            setCowState(oldState => ({ ...oldState, ...value }));
        }

        socket.emit('registerLiveGame')

        socket.on('updateSheep', onUpdateSheep)
        socket.on('updateVizier', onUpdateVizier)
        socket.on('updateCistern', onUpdateCistern)
        socket.on('updateGoldenAge', onUpdateGoldenAge)
        socket.on('updateCow', onUpdateCow)

        return (() => {
            socket.off('updateSheep', onUpdateSheep)
            socket.off('updateVizier', onUpdateVizier)
            socket.off('updateCistern', onUpdateCistern)
            socket.off('updateGoldenAge', onUpdateGoldenAge)
            socket.off('updateCow', onUpdateCow)
        })
    }, [socket.id]);

    return (
        <div className='border-solid border-zinc-600 border-2 flex flex-col'>

            <h1>Global</h1>
            <div className='sheep'>
                <h1>Sheep stuff</h1>
                <div className=''>
                    <button onClick={(e) => updateSheep({ showSheepPopup: true })} className={classNames('max-w-16', sheepState.showSheepPopup && 'selected')}>Show</button>
                    <button onClick={(e) => updateSheep({ showSheepPopup: false })} className={classNames('max-w-16', !sheepState.showSheepPopup && 'selected')}>Hide</button>
                    <select onChange={(e) => updateSheep({ neutralCount: Number(e.target.value), leftCount: 5, rightCount: 5 })} id="sheepMap" name="sheepMap" defaultValue={"Dry Arabia"}>
                        {maps?.map(map => <option value={map.neutralSheepCount}>{`${map.name}`}</option>)}
                    </select>
                </div>
                <div className='flex flex-row '>
                    <div className='w-24'>
                        <label>Left</label>
                        <input type="number" value={sheepState?.leftCount} onChange={(e) => updateSheep({ leftCount: Number(e.target.value) })} id="leftSheep" min="0" name="leftSheep" />
                    </div>
                    <div className='w-24'>
                        <label>Neutral</label>
                        <input type="number" value={sheepState?.neutralCount} onChange={(e) => updateSheep({ neutralCount: Number(e.target.value) })} id="neutralSheep" min="0" name="neutralSheep" />
                    </div>
                    <div className='w-24'>
                        <label>Right</label>
                        <input type="number" value={sheepState?.rightCount} onChange={(e) => updateSheep({ rightCount: Number(e.target.value) })} id="rightSheep" min="0" name="rightSheep" />
                    </div>
                </div>
                <button onClick={(e) => resetLiveGame({})} className={classNames('max-w-16', sheepState.showSheepPopup && 'selected')}>Reset</button>
                
            </div>

            <div className='border-solid border-zinc-600 border-2 flex flex-row'>
                <div className='vizier'>
                    <h1>Vizier</h1>
                    <div className='flex flex-row'>
                        <button onClick={(e) => updateVizier({ showVizierPopup: true })} className={classNames(vizierState.showVizierPopup && 'selected')}>Show</button>
                        <button onClick={(e) => updateVizier({ showVizierPopup: false })} className={classNames(!vizierState.showVizierPopup && 'selected')}>Hide</button>
                        <button onClick={(e) => updateVizier({ points: [0, 0, 0, 0, 0, 0, 0, 0] })} className=' bg-red-600'>RESET</button>

                    </div>
                    <div className='flex flex-row'>
                        <label>LeftSide</label>
                        <input type="checkbox" checked={vizierState.leftSide} onChange={(e) => updateVizier({ leftSide: e.target.checked })} id="leftSide" />
                    </div>

                    <div className='flex flex-row'>
                        <label>Has Landmark</label>
                        <input type="checkbox" checked={vizierState.hasLandmark} onChange={(e) => updateVizier({ hasLandmark: e.target.checked })} id="hasLandmark" />

                    </div>
                    <div className='flex flex-col'>
                        {vizierState && vizierState?.points?.map((vizState, index) =>
                            <div className='flex flex-row'>
                                <select className='border-solid border-zinc-600 border-[0.5px]' value={vizierState?.points[index]} onChange={(e) => {
                                    //Copy pasted from chatgpt, becuase I'm so confused and its 4am,, there has to be a better way right?... points[i] gave me a ", expected" error
                                    let newPoints = [...vizierState.points]
                                    newPoints[index] = Number(e.target.value)
                                    updateVizier({ points: newPoints })
                                }} id={`vizier${index}`} name={`vizier${index}`} defaultValue={0}>
                                    {vizier.map(viz => <option value={`${viz.id}`}>{`${viz.title}`}</option>)}
                                </select>
                                <div className='h-10' style={{ backgroundImage: "url('/Tech_Background.png')" }} >
                                    <img className='h-10' src={`/vizier/${getVizierByID(vizierState.points[index])}`} />
                                </div>
                            </div>
                        )}

                    </div>
                </div>
                <div className='flex flex-col'>
                    <div className='cistern border-solid border-zinc-600 border-2 pt-2'>
                        <div>
                            <button onClick={(e) => updateCistern({ showCisternLevel: true })} className={classNames('max-w-16', cisternState.showCisternLevel && 'selected')}>Show</button>
                            <button onClick={(e) => updateCistern({ showCisternLevel: false })} className={classNames('max-w-16', !cisternState.showCisternLevel && 'selected')}>Hide</button>
                        </div>
                        <div className='flex flex-row'>

                            <div>
                                <label>Level</label>
                                <input type="number" value={cisternState?.waterLevel} onChange={(e) => updateCistern({ waterLevel: Number(e.target.value) })} id="waterLevel" min="0" max="5" name="waterLevel" />
                            </div>
                            <div className={`rubik w-[70px] h-[70px]`} style={{ color: "#F7D79E" }} >
                                <WaterLevel waterLevel={cisternState?.waterLevel} widthHeight="w-[62px] h-[62px]" textClass="text-2xl w-[66px] h-[64px] flex text-center justify-center align-center items-center" />
                            </div>
                        </div>
                        <div className='flex flex-row'>
                            <label>LeftSide</label>
                            <input className='h-6' type="checkbox" checked={cisternState.leftSide} onChange={(e) => updateCistern({ leftSide: e.target.checked })} id="leftSide" />
                        </div>
                    </div>

                    <div className='goldenAge border-solid border-zinc-600 border-2 pt-2'>
                        <div>
                            <button onClick={(e) => updateGoldenAge({ showGoldenAgeLevel: true })} className={classNames('max-w-16', goldenAgeState.showGoldenAgeLevel && 'selected')}>Show</button>
                            <button onClick={(e) => updateGoldenAge({ showGoldenAgeLevel: false })} className={classNames('max-w-16', !goldenAgeState.showGoldenAgeLevel && 'selected')}>Hide</button>
                        </div>
                        <div className='flex flex-row'>

                            <div>
                                <label>Level</label>
                                <input type="number" value={goldenAgeState?.goldenAgeLevel} onChange={(e) => updateGoldenAge({ goldenAgeLevel: Number(e.target.value) })} id="goldenAgeLevel" min="0" max="5" name="goldenAgeLevel" />
                            </div>
                            <div className={`rubik w-[70px] h-[70px]`} style={{ color: "#F7D79E" }} >
                                <GoldenAge goldenAgeLevel={goldenAgeState?.goldenAgeLevel} widthHeight="w-[62px] h-[62px]" textClass="text-2xl w-[62px] h-[62px] flex text-center justify-center align-center items-center" />
                            </div>
                        </div>
                        <div className='flex flex-row'>
                            <label>LeftSide</label>
                            <input className='h-6' type="checkbox" checked={goldenAgeState.leftSide} onChange={(e) => updateGoldenAge({ leftSide: e.target.checked })} id="goldenLeftSide" />
                        </div>
                    </div>

                    <div className='maliCounter border-solid border-zinc-600 border-2 pt-2'>
                        <div>
                            <button onClick={(e) => updateCow({ showCowCounter: true })} className={classNames('max-w-16', cowState.showCowCounter && 'selected')}>Show</button>
                            <button onClick={(e) => updateCow({ showCowCounter: false })} className={classNames('max-w-16', !cowState.showCowCounter && 'selected')}>Hide</button>
                        </div>
                        <div className={`rubik ml-3`}>
                            <MalianCows cowCount={cowState.cowCount} />
                        </div>
                        <div className='flex flex-row'>
                            <div>
                                <label>Cow Count</label>
                                <input type="number" value={cowState?.cowCount} onChange={(e) => updateCow({ cowCount: Number(e.target.value) })} id="cowCounter" min="0" max="20" name="cowCounter" />
                            </div>
                        </div>
                        <div className='flex flex-row'>
                            <label>LeftSide</label>
                            <input className='h-6' type="checkbox" checked={cowState.leftSide} onChange={(e) => updateCow({ leftSide: e.target.checked })} id="cowLeftSide" />
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default LiveGameDashboard;
